import { useGet } from '@ngt/forms';
import { useMemo } from 'react';
import { SWRConfiguration, SWRResponse } from 'swr';
import { ContractGetMinExchangeDateByProjectId, ContractGetMinExchangeDateByProjectIdResponse } from '../../api/dtos';

const getData = (response?: SWRResponse<ContractGetMinExchangeDateByProjectIdResponse, ContractGetMinExchangeDateByProjectIdResponse>) => {
    return response?.data?.minExchangeDate;
}
const getError = (response?: SWRResponse<ContractGetMinExchangeDateByProjectIdResponse, ContractGetMinExchangeDateByProjectIdResponse>) => (response?.error ?? response?.data)?.responseStatus;
// const getAdditionalState = (response?: SWRResponse<StageGetSummaryCollectionByProjectIdResponse, StageGetSummaryCollectionByProjectIdResponse>) => ({});

const useMinExchangeDateByProjectId = (projectId?: number, configuration?: SWRConfiguration<ContractGetMinExchangeDateByProjectIdResponse, ContractGetMinExchangeDateByProjectIdResponse>) => {
    
    const request = useMemo(() => {
        return () => {
            return new ContractGetMinExchangeDateByProjectId({
                projectId: projectId
            });
        };
    }, [projectId])

    return useGet(request, { getData, getError }, configuration);
}

export default useMinExchangeDateByProjectId;